import axios from 'axios'
import router from '../router'

//域名统一管理
let baseURL = 'http://admin-api.drumsky.com:18818/1.0'; // 生产地址
// baseURL = process.env.NODE_ENV=== 'development'? 'http://admin-api.drumsky.com:18818/1.0': 'http://admin-api.drumsky.com:18818/1.0'
// let baseURL = 'https://tm.caifulife.cn/1.0'; // 击乐星空学生端测试地址
// 注意：由于需要部署到测试地址，我在项目中添加了很多 /drumsky_admin/
// 如果生产上文件地址报错，那么全局搜索 /drumsky_admin/ 将其替换成 / 后再打包尝试

// 请求拦截
axios.interceptors.request.use(
  (config) => {
    //随便写个值 绕过if判段  防止 axios 的 get delete方法不能设置 Content-Type
    if (config.method === 'get') {
      config.data = true
    } if (config.method === 'delete') {
      config.data = true
    }
    if (config.url.indexOf('login') === -1) {
      //登录成功  token 就会有 所有请求都必须携带token
      // 如果不是登录页的请求  没有token跳登录页
      if (localStorage['associationToken']) {
        config.headers.Authorization = 'Music ' + localStorage['associationToken'];
      }
      else {
        router.push('/login');
        // 取消请求
        // config.cancelToken;
        // return false;
      }
    }
    config.url = baseURL + config.url;
    console.log("请求路径：" + config.url);
    config.headers['Content-Type'] = 'application/json';

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    // 403  表示未登录
    if (response.data.code === 403) {
      console.log('表示未登录');
      console.log(response.data.code);
      router.push('/login');
      // return
    }
    return response
  },
  (error) => {
    // 请求的就扣错误会走这里
    // return Promise.reject(error.response.status)
    return { code: 408, msg: '请求异常' }
    // Promise.reject(error)
  }
);
export default axios



// WEBPACK FOOTER //
// ./src/request/http.js